import { jsxs as e, jsx as l } from "react/jsx-runtime";
const p = ({
  size: t = 780,
  testId: i = "empty-state-illustration"
}) => /* @__PURE__ */ e(
  "svg",
  {
    "data-testid": i,
    width: typeof t == "number" ? t : t.width,
    height: "auto",
    viewBox: "0 0 780 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_32822_58635)", children: [
        /* @__PURE__ */ l("rect", { width: "780", height: "480", fill: "white" }),
        /* @__PURE__ */ e("g", { clipPath: "url(#clip1_32822_58635)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M780 91.56L619.88 -0.459961H409.62L780 212.38V91.56Z",
              fill: "url(#paint0_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M409.62 -0.459961H199.36L780 333.22V212.4L765.52 204.08C755.12 198.1 746.78 189.08 741.62 178.24L736.3 167.04C726.04 145.44 703.74 132.16 679.86 133.44L663.18 134.34C651.8 134.94 640.5 132.26 630.64 126.58L409.62 -0.459961Z",
              fill: "url(#paint1_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0 -0.459961V5.80004L780 454.04V333.22L545.22 198.3C540.1 195.36 536.28 190.62 534.5 185C531.46 175.44 522.72 168.86 512.7 168.56L505.94 168.38C497.62 168.14 490.02 163.54 485.98 156.26L481.82 148.78C478.34 142.48 472.16 138.14 465.06 136.96L431.82 131.44C429.04 130.98 426.38 130.02 423.94 128.62L199.36 -0.459961H0Z",
              fill: "url(#paint2_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M780 -0.459961H619.88L780 91.56V-0.459961Z",
              fill: "url(#paint3_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0 126.62L614.1 479.54H780V454.04L551.62 322.8C545.84 319.48 541.36 314.3 538.92 308.08C534.2 296.06 522.18 288.54 509.3 289.56L504.7 289.92C498.8 290.38 492.9 289.06 487.78 286.1L0 5.7998V126.62Z",
              fill: "url(#paint4_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0 247.46L403.86 479.54H614.12L439.68 379.3C435.02 376.62 431.8 372.02 430.86 366.74C429 356.26 418.56 349.62 408.28 352.4L405.02 353.28C400.38 354.54 395.42 353.88 391.26 351.5L342.58 323.52C339.16 321.56 336.46 318.52 334.92 314.88L330.18 303.74C327.1 296.46 319.66 292.04 311.78 292.78L298 294.08C294.26 294.44 290.52 293.62 287.26 291.74L169.68 224.16C162.36 219.96 156.56 213.56 153.1 205.86L141.84 180.86C134.22 163.94 115.98 154.46 97.74 157.94L79.88 161.36C70.46 163.16 60.7 161.52 52.36 156.74L0 126.62V247.44V247.46Z",
              fill: "url(#paint5_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0 368.28L193.6 479.54H403.86L153.02 335.4C146.28 331.52 141.14 325.36 138.54 318.04L138.16 316.96C132.72 301.62 116.78 292.64 100.84 295.94C93.04 297.56 84.9 296.26 78 292.28L0 247.46V368.28Z",
              fill: "url(#paint6_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0 479.54H193.6L0 368.28V479.54Z",
              fill: "url(#paint7_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M780 -0.461914H0V479.538H780V-0.461914Z",
              fill: "url(#paint8_radial_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M579.88 288.458C633.938 288.458 677.76 278.402 677.76 265.998C677.76 253.594 633.938 243.538 579.88 243.538C525.822 243.538 482 253.594 482 265.998C482 278.402 525.822 288.458 579.88 288.458Z",
              fill: "url(#paint9_radial_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M534 371.538C621.261 371.538 692 348.705 692 320.538C692 292.372 621.261 269.538 534 269.538C446.739 269.538 376 292.372 376 320.538C376 348.705 446.739 371.538 534 371.538Z",
              fill: "url(#paint10_radial_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M422.72 292.179C507.065 292.179 575.44 279.177 575.44 263.139C575.44 247.1 507.065 234.099 422.72 234.099C338.375 234.099 270 247.1 270 263.139C270 279.177 338.375 292.179 422.72 292.179Z",
              fill: "url(#paint11_radial_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M160.596 138.105L184.676 165.965L183.163 167.273L159.083 139.413L160.596 138.105Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.022 167.061L167.242 135.001L169.037 134.118L184.817 166.178L183.022 167.061Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M182.938 166.812L175.238 127.651L177.201 127.266L184.901 166.426L182.938 166.812Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M182.922 166.545L185.982 125.345L187.976 125.493L184.916 166.693L182.922 166.545Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M194.23 129.24L184.89 166.86L182.949 166.378L192.289 128.758L194.23 129.24Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.057 166.114L201.857 134.054L203.582 135.065L184.782 167.125L183.057 166.114Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.186 165.94L207.006 140.18L208.474 141.538L184.654 167.298L183.186 165.94Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.423 165.751L210.863 150.051L211.856 151.787L184.416 167.487L183.423 165.751Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.668 165.652L214.728 157.592L215.23 159.528L184.17 167.588L183.668 165.652Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.336 167.432L156.196 147.972L157.362 146.347L184.502 165.807L183.336 167.432Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M183.625 167.574L154.085 158.474L154.674 156.562L184.214 165.663L183.625 167.574Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M182.971 166.936L170.931 130.796L172.828 130.164L184.868 166.304L182.971 166.936Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M580.776 260.704L597.196 279.704L595.683 281.012L579.263 262.012L580.776 260.704Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.542 280.8L584.782 258.94L586.577 258.057L597.337 279.917L595.542 280.8Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.458 280.552L590.198 253.852L592.161 253.466L597.421 280.166L595.458 280.552Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.441 280.285L597.521 252.185L599.516 252.332L597.436 280.432L595.441 280.285Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M603.77 254.938L597.41 280.598L595.469 280.117L601.829 254.457L603.77 254.938Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.576 279.852L608.396 257.992L610.121 259.004L597.301 280.864L595.576 279.852Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.705 279.678L611.965 262.118L613.433 263.477L597.173 281.037L595.705 279.678Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.943 279.491L614.663 268.791L615.656 270.527L596.936 281.227L595.943 279.491Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M596.188 279.39L617.388 273.89L617.89 275.826L596.69 281.326L596.188 279.39Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.856 281.172L577.356 267.912L578.522 266.286L597.022 279.546L595.856 281.172Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M596.145 281.314L576.005 275.114L576.593 273.202L596.733 279.402L596.145 281.314Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M595.49 280.676L587.29 256.036L589.188 255.404L597.388 280.044L595.49 280.676Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M144.04 309.36H185.84C185.84 309.36 182.44 294.6 177.44 280.92C172.44 267.24 152.74 280.5 149.58 287.72C146.42 294.94 144.02 309.34 144.02 309.34L144.04 309.36Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M573.46 417.16C578.44 423.84 608.68 417.16 608.68 417.16C608.68 417.16 609.98 411.22 605.76 401.58C601.56 391.94 581.06 401.52 578.4 406.6C575.74 411.68 568.48 410.46 573.44 417.16H573.46Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M555.919 405.558C553.879 408.898 541.459 405.558 541.459 405.558C541.459 405.558 541.219 405.098 542.959 400.258C544.699 395.418 552.799 397.738 553.899 400.258C554.999 402.778 557.979 402.198 555.939 405.538L555.919 405.558Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M209.599 319.319C207.559 322.659 195.139 319.319 195.139 319.319C195.139 319.319 194.899 318.859 196.639 314.019C198.379 309.179 206.479 311.499 207.579 314.019C208.679 316.539 211.659 315.959 209.619 319.299L209.599 319.319Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M234.379 343.639C229.759 346.979 201.639 343.639 201.639 343.639C201.639 343.639 201.099 343.179 205.019 338.339C208.939 333.499 227.299 335.819 229.779 338.339C232.259 340.859 238.999 340.279 234.379 343.619V343.639Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M495.26 144.999C495.26 144.999 529.7 155.639 541.82 147.539C553.94 139.439 541.16 136.319 535.2 128.259C529.24 120.199 505.68 128.019 501.9 132.259C498.12 136.499 495.26 144.979 495.26 144.979V144.999Z",
              fill: "#F2F0E9"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M284.179 216.259H291.179C292.779 216.259 294.059 214.959 294.059 213.379V206.939C294.059 204.459 296.059 202.459 298.539 202.459C301.019 202.459 303.019 204.459 303.019 206.939V217.559C303.019 221.779 299.599 225.199 295.379 225.199H284.179V258.239C284.179 262.939 280.379 266.739 275.679 266.739C270.979 266.739 267.179 262.939 267.179 258.239V210.799H255.039C250.819 210.799 247.399 207.379 247.399 203.159V192.539C247.399 190.059 249.399 188.059 251.879 188.059C254.359 188.059 256.359 190.059 256.359 192.539V198.979C256.359 200.579 257.639 201.859 259.239 201.859H267.199V130.639C267.199 125.939 270.999 122.139 275.699 122.139C280.399 122.139 284.199 125.939 284.199 130.639V216.259H284.179Z",
              fill: "url(#paint12_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M275.699 123.139C271.552 123.139 268.199 126.491 268.199 130.639V202.859H259.239C257.087 202.859 255.359 201.131 255.359 198.979V192.539C255.359 190.611 253.807 189.059 251.879 189.059C249.952 189.059 248.399 190.611 248.399 192.539V203.159C248.399 206.826 251.372 209.799 255.039 209.799H268.179V258.239C268.179 262.386 271.532 265.739 275.679 265.739C279.827 265.739 283.179 262.386 283.179 258.239V224.199H295.379C299.047 224.199 302.019 221.226 302.019 217.559V206.939C302.019 205.011 300.467 203.459 298.539 203.459C296.612 203.459 295.059 205.011 295.059 206.939V213.379C295.059 215.506 293.336 217.259 291.179 217.259H284.179V216.259H283.199V130.639C283.199 126.491 279.847 123.139 275.699 123.139ZM285.199 215.259V130.639C285.199 125.386 280.952 121.139 275.699 121.139C270.447 121.139 266.199 125.386 266.199 130.639V200.859H259.239C258.192 200.859 257.359 200.026 257.359 198.979V192.539C257.359 189.506 254.912 187.059 251.879 187.059C248.847 187.059 246.399 189.506 246.399 192.539V203.159C246.399 207.931 250.267 211.799 255.039 211.799H266.179V258.239C266.179 263.491 270.427 267.739 275.679 267.739C280.932 267.739 285.179 263.491 285.179 258.239V226.199H295.379C300.152 226.199 304.019 222.331 304.019 217.559V206.939C304.019 203.906 301.572 201.459 298.539 201.459C295.507 201.459 293.059 203.906 293.059 206.939V213.379C293.059 214.411 292.223 215.259 291.179 215.259H285.199Z",
              fill: "#A1C0FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M358.279 177.198H356.279C349.859 177.198 344.659 171.998 344.659 165.578V149.418C344.659 145.658 347.699 142.598 351.479 142.598C355.259 142.598 358.299 145.638 358.299 149.418V159.198C358.299 161.618 360.259 163.578 362.679 163.578H373.339V122.318C373.339 115.178 379.139 109.378 386.279 109.378C393.419 109.378 399.219 115.178 399.219 122.318V230.658H411.319C413.739 230.658 415.699 228.698 415.699 226.278V216.498C415.699 212.738 418.739 209.678 422.519 209.678C426.279 209.678 429.339 212.718 429.339 216.498V232.658C429.339 239.078 424.139 244.278 417.719 244.278H415.719H399.239V316.458C399.239 323.598 393.439 329.398 386.299 329.398C379.159 329.398 373.359 323.598 373.359 316.458V266.198H358.319H356.319C349.899 266.198 344.699 260.998 344.699 254.578V238.418C344.699 234.658 347.739 231.598 351.519 231.598C355.299 231.598 358.339 234.638 358.339 238.418V248.198C358.339 250.618 360.299 252.578 362.719 252.578H373.379V177.218H358.339L358.279 177.198Z",
              fill: "url(#paint13_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M386.279 110.378C379.691 110.378 374.339 115.73 374.339 122.318V164.578H362.679C359.707 164.578 357.299 162.17 357.299 159.198V149.418C357.299 146.19 354.707 143.598 351.479 143.598C348.253 143.598 345.659 146.208 345.659 149.418V165.578C345.659 171.446 350.411 176.198 356.279 176.198H358.441L358.501 176.218H374.379V253.578H362.719C359.747 253.578 357.339 251.17 357.339 248.198V238.418C357.339 235.19 354.747 232.598 351.519 232.598C348.293 232.598 345.699 235.208 345.699 238.418V254.578C345.699 260.446 350.451 265.198 356.319 265.198H374.359V316.458C374.359 323.046 379.711 328.398 386.299 328.398C392.887 328.398 398.239 323.046 398.239 316.458V243.278H417.719C423.587 243.278 428.339 238.526 428.339 232.658V216.498C428.339 213.272 425.729 210.678 422.519 210.678C419.293 210.678 416.699 213.288 416.699 216.498V226.278C416.699 229.25 414.291 231.658 411.319 231.658H398.219V122.318C398.219 115.73 392.867 110.378 386.279 110.378ZM372.339 122.318C372.339 114.626 378.587 108.378 386.279 108.378C393.971 108.378 400.219 114.626 400.219 122.318V229.658H411.319C413.187 229.658 414.699 228.146 414.699 226.278V216.498C414.699 212.188 418.185 208.678 422.519 208.678C426.83 208.678 430.339 212.164 430.339 216.498V232.658C430.339 239.63 424.691 245.278 417.719 245.278H400.239V316.458C400.239 324.15 393.991 330.398 386.299 330.398C378.607 330.398 372.359 324.15 372.359 316.458V267.198H356.319C349.347 267.198 343.699 261.55 343.699 254.578V238.418C343.699 234.108 347.185 230.598 351.519 230.598C355.851 230.598 359.339 234.086 359.339 238.418V248.198C359.339 250.066 360.851 251.578 362.719 251.578H372.379V178.218H358.177L358.117 178.198H356.279C349.307 178.198 343.659 172.55 343.659 165.578V149.418C343.659 145.108 347.145 141.598 351.479 141.598C355.811 141.598 359.299 145.086 359.299 149.418V159.198C359.299 161.066 360.811 162.578 362.679 162.578H372.339V122.318Z",
              fill: "#A1C0FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M509.54 204.579C507.18 204.819 505.46 206.979 505.46 209.359V215.639C505.46 217.259 504.14 218.559 502.54 218.559H495.42V183.619C495.42 179.099 492.12 175.079 487.62 174.639C482.46 174.139 478.12 178.199 478.12 183.239V203.899H470.04C468.42 203.899 467.12 202.579 467.12 200.979V194.699C467.12 192.319 465.4 190.159 463.04 189.919C460.32 189.639 458.02 191.779 458.02 194.439V205.239C458.02 209.539 461.5 212.999 465.78 212.999H478.12V260.779C478.12 265.339 481.46 269.439 486 269.839C491.12 270.279 495.42 266.259 495.42 261.219V227.619H506.8C511.1 227.619 514.56 224.139 514.56 219.859V209.059C514.56 206.399 512.26 204.259 509.54 204.539V204.579Z",
              fill: "url(#paint14_linear_32822_58635)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M477.12 183.24C477.12 177.617 481.961 173.087 487.716 173.644C492.781 174.139 496.42 178.64 496.42 183.62V217.56H502.54C503.592 217.56 504.46 216.703 504.46 215.64V209.36C504.46 206.835 506.092 204.445 508.54 203.755V203.637L509.437 203.545C512.755 203.203 515.56 205.815 515.56 209.06V219.86C515.56 224.69 511.653 228.62 506.8 228.62H496.42V261.219C496.42 266.842 491.622 271.326 485.914 270.836L485.912 270.836C480.793 270.385 477.12 265.792 477.12 260.779V214H465.78C460.949 214 457.02 210.093 457.02 205.24V194.44C457.02 191.195 459.824 188.583 463.142 188.925L463.04 189.92L463.141 188.925C463.141 188.925 463.142 188.925 463.142 188.925C466.079 189.224 468.12 191.878 468.12 194.7V200.98C468.12 202.032 468.976 202.9 470.04 202.9H477.12V203.9H478.12V202.9H477.12V183.24ZM487.523 175.635C482.958 175.193 479.12 178.782 479.12 183.24V204.9H470.04C467.863 204.9 466.12 203.127 466.12 200.98V194.7C466.12 192.762 464.72 191.096 462.938 190.914L462.937 190.914C460.815 190.696 459.02 192.364 459.02 194.44V205.24C459.02 208.986 462.05 212 465.78 212H479.12V260.779C479.12 264.886 482.125 268.493 486.085 268.843C490.617 269.233 494.42 265.677 494.42 261.219V226.62H506.8C510.546 226.62 513.56 223.589 513.56 219.86V209.06C513.56 207.164 512.062 205.608 510.185 205.519L509.641 205.574C507.859 205.756 506.46 207.422 506.46 209.36V215.64C506.46 217.816 504.687 219.56 502.54 219.56H494.42V183.62C494.42 179.559 491.458 176.02 487.523 175.635Z",
              fill: "#A1C0FF"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ e("defs", { children: [
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint0_linear_32822_58635",
            x1: "571.76",
            y1: "119.414",
            x2: "622.806",
            y2: "-8.8201",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint1_linear_32822_58635",
            x1: "453.42",
            y1: "192.834",
            x2: "517.098",
            y2: "32.8218",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint2_linear_32822_58635",
            x1: "338.96",
            y1: "267.792",
            x2: "415.297",
            y2: "76.008",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint3_linear_32822_58635",
            x1: "690.1",
            y1: "46.0064",
            x2: "721.633",
            y2: "-33.2199",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint4_linear_32822_58635",
            x1: "284.74",
            y1: "337.684",
            x2: "363.091",
            y2: "140.846",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint5_linear_32822_58635",
            x1: "208.64",
            y1: "391.108",
            x2: "279.308",
            y2: "213.545",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint6_linear_32822_58635",
            x1: "116.66",
            y1: "438.207",
            x2: "169.72",
            y2: "304.918",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint7_linear_32822_58635",
            x1: "29.46",
            y1: "480.581",
            x2: "67.5895",
            y2: "384.782",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.18", stopColor: "#F8F6EF" }),
              /* @__PURE__ */ l("stop", { offset: "0.46", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "radialGradient",
          {
            id: "paint8_radial_32822_58635",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(390.12 244.703) scale(385.08 234.899)",
            children: [
              /* @__PURE__ */ l("stop", { stopColor: "#F2F0E9", stopOpacity: "0" }),
              /* @__PURE__ */ l("stop", { offset: "0.23", stopColor: "#F2F0E9", stopOpacity: "0" }),
              /* @__PURE__ */ l("stop", { offset: "0.36", stopColor: "#F2F0E9", stopOpacity: "0.04" }),
              /* @__PURE__ */ l("stop", { offset: "0.47", stopColor: "#F3F1EB", stopOpacity: "0.1" }),
              /* @__PURE__ */ l("stop", { offset: "0.57", stopColor: "#F4F2EC", stopOpacity: "0.18" }),
              /* @__PURE__ */ l("stop", { offset: "0.67", stopColor: "#F5F4EF", stopOpacity: "0.28" }),
              /* @__PURE__ */ l("stop", { offset: "0.75", stopColor: "#F7F6F1", stopOpacity: "0.41" }),
              /* @__PURE__ */ l("stop", { offset: "0.83", stopColor: "#F9F8F5", stopOpacity: "0.56" }),
              /* @__PURE__ */ l("stop", { offset: "0.91", stopColor: "#FBFBF9", stopOpacity: "0.74" }),
              /* @__PURE__ */ l("stop", { offset: "0.98", stopColor: "#FEFDFD", stopOpacity: "0.93" }),
              /* @__PURE__ */ l("stop", { offset: "1", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "radialGradient",
          {
            id: "paint9_radial_32822_58635",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(498.107 266.546) rotate(1.66418) scale(148.166 10.3679)",
            children: [
              /* @__PURE__ */ l("stop", { stopColor: "#A1C0FF", stopOpacity: "0.5" }),
              /* @__PURE__ */ l("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "radialGradient",
          {
            id: "paint10_radial_32822_58635",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(402 321.782) rotate(2.34033) scale(239.271 23.5328)",
            children: [
              /* @__PURE__ */ l("stop", { stopColor: "#A1C0FF", stopOpacity: "0.5" }),
              /* @__PURE__ */ l("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "radialGradient",
          {
            id: "paint11_radial_32822_58635",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(295.131 263.847) rotate(1.37919) scale(231.149 13.4071)",
            children: [
              /* @__PURE__ */ l("stop", { stopColor: "#A1C0FF", stopOpacity: "0.5" }),
              /* @__PURE__ */ l("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint12_linear_32822_58635",
            x1: "247.379",
            y1: "194.439",
            x2: "303.019",
            y2: "194.439",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.45", stopColor: "#EDF2FC" }),
              /* @__PURE__ */ l("stop", { offset: "0.54", stopColor: "#DDE6FF" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint13_linear_32822_58635",
            x1: "344.659",
            y1: "219.378",
            x2: "429.319",
            y2: "219.378",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.45", stopColor: "#EDF2FC" }),
              /* @__PURE__ */ l("stop", { offset: "0.54", stopColor: "#DDE6FF" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "paint14_linear_32822_58635",
            x1: "458",
            y1: "222.279",
            x2: "514.56",
            y2: "222.279",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { offset: "0.45", stopColor: "#EDF2FC" }),
              /* @__PURE__ */ l("stop", { offset: "0.54", stopColor: "#DDE6FF" })
            ]
          }
        ),
        /* @__PURE__ */ l("clipPath", { id: "clip0_32822_58635", children: /* @__PURE__ */ l("rect", { width: "780", height: "480", fill: "white" }) }),
        /* @__PURE__ */ l("clipPath", { id: "clip1_32822_58635", children: /* @__PURE__ */ l(
          "rect",
          {
            width: "780",
            height: "480",
            fill: "white",
            transform: "translate(0 -0.461914)"
          }
        ) })
      ] })
    ]
  }
);
export {
  p as EmptyStateIllustration
};
//# sourceMappingURL=index.es463.js.map
